import { FileUploaderAPI, MaxFileSizeOptions } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { FileProviderData } from '../constants/file-provider-enum';
import { FileUploaderRules } from '../interfaces/file-uploader-rules';
import { SECURE_IMAGE_EXTENSIONS } from '../constants/application-constants';

export class FileRuleUtils {

  static async validateFileUploaderRules(fileUploaderApi: FileUploaderAPI): Promise<void> {

    fileUploaderApi.setFileHandlerProviderName(FileProviderData.fileProvider);
    const response = await HttpService.get(APPLICATION_ENDPOINTS.GET_FILES_RULES, {});
    const fileRules = response.body as FileUploaderRules;
    if(fileRules.fileExtension) {
      this.setFileUploaderRules(fileUploaderApi, fileRules);
    } else {
      fileUploaderApi.setAllowedTypes([...SECURE_IMAGE_EXTENSIONS]);
    }

  }

  static setFileUploaderRules(fileUploaderApi: FileUploaderAPI, filesRules: FileUploaderRules): void {

    const fileExtension: string[] = [];

    const fileSize = {
      maxSize: filesRules.fileSize,
      sizeUnit: 'MB',
    } as MaxFileSizeOptions;

    const extensions: string[] = filesRules.fileExtension.split(';');
    extensions.forEach(extension => {
      extension = '.' + extension;
      fileExtension.push(extension);
    });
    fileUploaderApi.setMaxFileSize(fileSize);
    fileUploaderApi.setAllowedTypes(fileExtension);
  }

}
